<template>
  <v-snackbar v-model="show" top :timeout="timeout">
    <div class="max-width d-flex align-center justify-space-between">
      <span class="subtitle-1">{{ message }}</span>
      <!-- <v-spacer /> -->
      <v-btn :color="status" class="" text @click="show = false">
        Close
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
// import { mapGetters } from 'vuex'
export default {
  name: 'loading',
  props: {},
  components: {},
  data() {
    return {
      show: false,
      message: '',
      status: 'error',
      timeout: 5000
    }
  },
  created() {
    this.$store.watch(
      state => state.general.snackmsg,
      () => {
        const msg = this.$store.state.general.snackmsg
        if (msg !== '') {
          this.message = this.$store.state.general.snackmsg
          this.status = this.$store.state.general.snackstatus
          this.show = true
          const data = {
            msg: '',
            status: ''
          }
          this.$store.commit('general/SET_SNACKBAR', data)
        }
      }
    )
  }
}
</script>

<style lang="scss" scoped></style>
